import { Injectable } from '@angular/core';
import { createPoliceDataIS, createPoliceDataStatusIS, getPoliceDataIS } from '@views/interfaces/services/policyData.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FormEventService {
  private get: getPoliceDataIS;
  public GetSubject = new BehaviorSubject<getPoliceDataIS>({});
  public GetObservable = this.GetSubject.asObservable();

  private save: createPoliceDataIS;
  public SaveSubject = new BehaviorSubject<createPoliceDataIS>({
    savingBeneficiaries: false,
    savingBasicInformation: false,
  });
  public SaveObservable = this.SaveSubject.asObservable();

  private getStatus: createPoliceDataStatusIS;
  public GetStatusSubject = new BehaviorSubject<createPoliceDataStatusIS>({});
  public GetStatusObservable = this.GetStatusSubject.asObservable();

  constructor() {}

  setGetSubject(get: getPoliceDataIS) {
    this.get = {...this.get, ...get};
    this.GetSubject.next(this.get);
  }
  setSaveSubject(save: createPoliceDataIS) {
    this.save = {...this.save, ...save};
    this.SaveSubject.next(this.save);
  }
  setGetStatusSubject(getStatus: createPoliceDataStatusIS) {
    this.getStatus = {...this.getStatus, ...getStatus};
    this.GetStatusSubject.next(this.getStatus);
  }
}

